import React from 'react';

import styles from './StandardModalLayout.module.scss';

const StandardModalLayout = ({
  header,
  body,
  footer
}) => {
  return (
    <div className={styles.modal}>
      <div className={styles.modalHeader}>
        {header}
      </div>

      <div className={styles.modalBody}>
        {body}
      </div>

      <div className={styles.modalFooter}>
        {footer}
      </div>
    </div>
  );
};

export default StandardModalLayout;